<template>
  <!-- <div class="container-fluid p-0" style="background-image: url('${import.meta.env.VITE_NGINX_URL}/23299312_m.jpg'); background-size: cover; background-position: center; min-height: 100vh;"> -->
    <div class="song-list-container">
      <div class="container">
        <AddMyFavorite ref="addFavoriteRef" />
        <div class="song-list">
          <span class="text-white"><h2>字劃點歌</h2></span>
          <div v-if="loading" class="loading-indicator">Loading...</div>
          <div v-else class="song-content">
            <ul class="song-items">
              <li v-for="song in songs" :key="song.id" @click="showDetails(song)">
                <span class="text-white">{{ song.songclass }}--{{ song.songname }}--{{ song.songstar.map(star => star.starname).join(', ') }}</span>
              </li>
            </ul>
            <div class="custom-pagination-container" v-if="totalPages > 1">
              <div class="custom-pagination-wrapper">
                <button 
                  class="custom-pagination-btn prev"
                  :class="{ 'disabled': !hasPrevPage }"
                  @click="prevPage"
                >
                  <i class="fas fa-chevron-left"></i> 上頁
                </button>
                <span class="custom-page-info">{{ currentPage }} / {{ totalPages }}</span>
                <button 
                  class="custom-pagination-btn next"
                  :class="{ 'disabled': !hasNextPage }"
                  @click="nextPage"
                >
                  下頁 <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <!-- <hr class="page-end-line">
            <hr class="page-end-line"> -->
            <!-- <hr class="page-end-line">
            <hr class="page-end-line">
            <hr class="page-end-line"> -->
            <div class="bottom-spacer"></div>
          </div>
        </div>
        <!-- <br><br><br><br> -->
        <div v-if="showModal" class="modal">
          <div class="modal-content">
            <span class="close" @click="closeModal">&times;</span>
            <p>歌曲名稱: {{ selectedSong.songname }}</p>
            <!-- <p>檔案名稱: {{ selectedSong.filename }}</p> -->
            <!-- <p class="mb-0">通路＋版權費：本曲收費{{ selectedSong.songChargeA }}+{{ selectedSong.songChargeB }}元</p>
            <p>播放後收費，播放前可取消！</p> -->

            <button @click="confirmSelection">確認</button>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { usePlaylistStore } from '../store/usePlaylistStore';
import { useUserStore } from '@/store/useUserStore';
import AddMyFavorite from './addmyfavorite.vue';

// Define reactive properties
const songs = ref([]);
const loading = ref(false);
const currentPage = ref(1);
const totalPages = ref(1);
const selectedSong = ref(null);
const showModal = ref(false);

// Compute if there are previous or next pages
// const hasPrevPage = computed(() => currentPage.value > 1);
// const hasNextPage = computed(() => currentPage.value < totalPages.value);
const hasPrevPage = ref(false);
const hasNextPage = ref(false);

// Import playlist store
const { playlist, addSong, removeSong } = usePlaylistStore();
const userStore = useUserStore();


// Define props
const props = defineProps({
  param1: String,
  param2: String,
});

const addFavoriteRef = ref(null);

// Function to fetch songs
const fetchSongs = async (page = 1) => {
  
  loading.value = true;
  try {
    // 使用相對路徑，讓 axios 的 baseURL 自動處理
    const response = await axios.get('/songsdb/', {
      params: {
        songclass: props.param1,
        songnuchar: parseInt(props.param2, 16),
        page: page,
      },
    });
    songs.value = response.data.results;
    hasPrevPage.value = !!response.data.previous;
    hasNextPage.value = !!response.data.next;
    currentPage.value = page;
    // totalPages.value = Math.ceil(response.data.count / response.data.results.length);
    totalPages.value = Math.ceil(response.data.count / 16);
    // console.error(currentPage.value);
    // console.error(totalPages.value);

  } catch (error) {
    console.error('There was an error fetching the songs:', error);
  } finally {
    loading.value = false;
  }
};

// Function to show song details
const showDetails = (song) => {
  selectedSong.value = song;
  showModal.value = true;
};

// Function to close modal
const closeModal = () => {
  showModal.value = false;
};

// Function to confirm song selection
const confirmSelection = async () => {
  try {
    addSong({
      id: selectedSong.value.id,
      songname: selectedSong.value.songname,
      filename: selectedSong.value.filename,
      stateA: false,
      stateB: false,
    });
    
    // 準備請求數據
    const requestData = {
      songsname: selectedSong.value.id,
    };
    
    // 如果用戶已登入，添加 customerno；否則允許未登入用戶點歌（customerno 為 null）
    const customerId = userStore.user?.customer_id;
    if (customerId) {
      // 從 'C104' 中提取數字 104
      const numericUserId = parseInt(customerId.replace('C', ''));
      if (!isNaN(numericUserId)) {
        requestData.customerno = numericUserId;
      } else {
        console.warn('無法解析用戶 ID:', customerId);
      }
    } else {
      console.log('用戶未登入，將創建無用戶 ID 的歌曲請求');
    }
    
    // 使用相對路徑，讓 axios 的 baseURL 自動處理
    await axios.post('/songsrequest/create/', requestData);
    console.log('SongList 歌曲請求:', requestData);

    // alert('確認成功');
    showModal.value = false;
  } catch (error) {
    console.error('There was an error confirming the selection:', error);
  }
};

// Function to go to previous page
const prevPage = () => {
  if (hasPrevPage.value) {
    fetchSongs(currentPage.value - 1);
  }
};

// Function to go to next page
const nextPage = () => {
  if (hasNextPage.value) {
    fetchSongs(currentPage.value + 1);
  }
};

// Compute visible pages for pagination
const visiblePages = computed(() => {
  const startPage = Math.floor((currentPage.value - 1) / 15) * 15 + 1;
  const endPage = Math.min(startPage + 14, totalPages.value);
  return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
});

// Fetch songs on component mount
onMounted(() => fetchSongs(currentPage.value));

// 添加到最愛
const addToFavorite = (songId) => {
  console.log('嘗試添加歌曲到最愛，songId:', songId);
  if (addFavoriteRef.value) {
    addFavoriteRef.value.openAddFavorite(songId);
  } else {
    console.error('addFavoriteRef is null');
  }
};
</script>

<style scoped>
/* 主容器樣式 - 設置最大高度和滾動 */
.song-list-container {
  max-height: calc(100vh - 100px) ;
  overflow-y: auto;
  padding-bottom: 20px;
}

.container {
  display: flex;
  flex-direction: column;
}

/* 歌曲列表樣式 */
.song-list {
  flex: 1;
  margin: 10px;
  display: flex;
  flex-direction: column;
}

/* 歌曲內容區域 - 確保可以滾動 */
.song-content {
  display: flex;
  flex-direction: column;
  min-height: 300px; /* 確保有足夠的高度 */
}

/* 歌曲項目列表 */
.song-items {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
}

.song-list li {
  cursor: pointer;
  padding: 5px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.song-list li:hover {
  background-color: rgba(240, 240, 240, 0.4);
}

/* 加載指示器 */
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: white;
}

/* 模態框樣式 */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200000; /* 確保在待播歌區之上 */
}

.modal-content {
  background-color: #6488b0;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  max-width: 500px;
  position: relative;
  z-index: 200001; /* 比 modal 背景更高 */
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover, .close:focus {
  color: black;
}

.text-white {
  color: white;
}

/* 自定義分頁樣式 */
/* .custom-pagination-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.custom-pagination-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  width: auto;
  max-width: 100%;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 10px;
  white-space: nowrap;
}

.custom-pagination-btn {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 5px 10px;
  margin: 0 5px;
  border: none;
  border-radius: 5px;
  background-color: #343a40;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.custom-pagination-btn:hover:not(.disabled) {
  background-color: #495057;
}

.custom-pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-page-info {
  display: inline-block;
  white-space: nowrap;
  padding: 5px;
  margin: 0 5px;
  color: white;
  font-size: 0.9rem;
} */

.custom-pagination-container {
  width: 100%;
  display: block;
  margin: 10px 0;
  padding: 0;
  background: none;
  list-style: none;
}

.custom-pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
}

.custom-pagination-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.8rem;
  border: none;
  border-radius: 15px;
  background: linear-gradient(145deg, #007bff, #0056b3);
  color: white;
  font-weight: normal;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-pagination-btn:hover:not(.disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.custom-pagination-btn.disabled {
  background: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.7;
}

.custom-page-info {
  font-size: 0.9rem;
  color: #666;
  padding: 0.3rem 0.8rem;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.fas {
  font-size: 0.8rem;
}


/* 響應式樣式 */
@media (max-width: 768px) {
  .song-list-container {
  max-height: calc(100vh - 300px) ;
  overflow-y: auto;
  padding-bottom: 50px;
}

  /* .custom-pagination-container {
    margin-bottom: 50px !important;
    padding-bottom: 10px !important;
  } */
  .custom-pagination-wrapper {
    padding: 3px 8px;
    margin-bottom: 30px;
    }
  
  .custom-pagination-btn {
    padding: 3px 8px;
    margin: 0 3px;
    font-size: 0.85rem;
  }
  
  .custom-page-info {
    padding: 3px;
    margin: 0 3px;
    font-size: 0.85rem;
  }
}

/* 按鈕樣式 */
button {
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

button:hover {
  background-color: #0069d9;
}

.btn-favorite {
  padding: 5px 15px;
  background-color: #ff69b4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

.btn-favorite:hover {
  background-color: #ff1493;
}

.page-end-line {
  border: 1;
  height: 10px;
  background: rgb(50, 10, 10);
  margin-bottom: -13rem 0;
}
</style>
  